import { render, staticRenderFns } from "./CampaignTable.vue?vue&type=template&id=6d8f4f1e&"
import script from "./CampaignTable.vue?vue&type=script&lang=js&"
export * from "./CampaignTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports